// extracted by mini-css-extract-plugin
module.exports = {"reloading":"Widget_reloading__2EekH","widget":"Widget_widget__ZjgBs"};